const publicBucketHost = process.env.NEXT_PUBLIC_R2_BUCKET_PUBLIC_HOST;

export function toPublicBucketUrl(
  originalUrl: string | null | undefined,
): string | undefined {
  if (!originalUrl) return undefined;
  if (!publicBucketHost) return originalUrl;

  try {
    const { pathname, host } = new URL(originalUrl);
    if (host === publicBucketHost) return originalUrl;
    return `https://${publicBucketHost}${pathname}`;
  } catch {
    return originalUrl;
  }
}
